import { useEffect, useState } from "react";
import { FB_GROUP_URL } from "../constants/community";
import { useT } from "../i18n";
import { useToast } from "../lib/toast";
import { Icon } from "./Icon";

// Shared community CTA card (Facebook group). Used on the Community page and as a
// pre-footer band on the public homepage. Pass `banner` to reuse an already-fetched
// showcase image; omit it and the card fetches communityBanner from the manifest itself.
export function CommunityCard({ banner: bannerProp }: { banner?: string }) {
  const tr = useT();
  const toast = useToast((s) => s.show);
  const [banner, setBanner] = useState(bannerProp ?? "");

  useEffect(() => {
    if (bannerProp !== undefined) { setBanner(bannerProp); return; }
    fetch("/showcase/showcase.json")
      .then((r) => (r.ok ? r.json() : null))
      .then((d: { communityBanner?: string } | null) => { if (d?.communityBanner) setBanner(d.communityBanner); })
      .catch(() => {});
  }, [bannerProp]);

  function join() {
    if (FB_GROUP_URL) window.open(FB_GROUP_URL, "_blank", "noopener");
    else toast(tr("Lien du groupe Facebook bientôt disponible"), "ok");
  }

  return (
    <button className="community-card" onClick={join}
      style={banner ? { backgroundImage: `linear-gradient(180deg, rgba(6,9,15,0.45) 0%, rgba(6,9,15,0.9) 85%), url(${banner})` } : undefined}>
      <div className="community-inner">
        <span className="community-badge"><Icon name="users" size={13} /> {tr("Communauté")}</span>
        <h2 className="community-title">{tr("Rejoins notre groupe Facebook")}</h2>
        <p className="community-sub">{tr("Échange avec les autres créateurs, montre tes impressions, pose tes questions et découvre les dernières tendances 3D.")}</p>
        <span className="btn primary lg community-cta"><Icon name="facebook" size={17} /> {FB_GROUP_URL ? tr("Rejoindre le groupe") : tr("Bientôt disponible")}</span>
      </div>
    </button>
  );
}
